import { render, staticRenderFns } from "./app-settings.vue?vue&type=template&id=ed4c66a4&scoped=true"
import script from "./app-settings.vue?vue&type=script&lang=js"
export * from "./app-settings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed4c66a4",
  null
  
)

export default component.exports